import React from "react";
import "./HowWeDid.css";

const HowWeDid = () => {
  return (
    <div className="howWeDid" id="howwedid">
      <div className="howWeDid__title">
        <h2>How WE DO IT</h2>
        <p>We help you harness the power of data to reach customers using personalised email.</p>
        <hr />
      </div>
      <div className="howWeDid__content">
        <div className="howWeDid__content__sec1">
          <div className="howWeDid__content__sec__icon">
            <img
              src={require("../Img/howwedoit/analysis.png")}
              alt="HowWeDoIcon"
            />
          </div>
          <h3>Analysis & Strategy</h3>
          <p>
            Our experts understand the experience of Shopify, Magento, Bigcommerce and Woocommerce stores combined 
            with Klaviyo's seamless integrations mean we analyse much more than open rates and unsubscribes when 
            creating an email automation strategy for you.
          </p>
        </div>
        <div className="howWeDid__content__sec2">
          <div className="howWeDid__content__sec__icon">
            <img
              src={require("../Img/howwedoit/implementation.png")}
              alt="HowWeDoIcon"
            />
          </div>
          <h3>Implementation</h3>
          <p>
            Once we know how your current database is interacting with email and what their pain points are, 
            we will work with your teams to set up phases to make sure all emails are tested and perfect before 
            they are set live.
          </p>
        </div>
        <div className="howWeDid__content__sec1">
          <div className="howWeDid__content__sec__icon">
            <img
              src={require("../Img/howwedoit/optimization.png")}
              alt="HowWeDoIcon"
            />
          </div>
          <h3>Evaluation & Optimization</h3>
          <p>
            Our experience with eCommerce and Klaviyo email automation means that we've seen a lot of successful 
            flows and campaigns over time. We know what works across a wide range of industries, which means we can 
            optimise your account to get the best possible results.
          </p>
        </div>
        <div className="howWeDid__content__sec2">
          <div className="howWeDid__content__sec__icon">
            <img
              src={require("../Img/howwedoit/analysis.png")}
              alt="HowWeDoIcon"
            />
          </div>
          <h3>Analytics & Reporting</h3>
          <p>
           Through Klaviyo, we can provide a variety of ways for you to understand performance quickly, 
           so you can spend more time figuring out what to do next and grow faster.
          </p>
        </div>
      </div>
    </div>
  );
};

export default HowWeDid;
